import { put, select } from "redux-saga/effects";

import type { TopicLatestApplySearchCriteria } from "domains/knowledgeFeed/actionTypes";
import { getLatestSearchCriteria } from "domains/knowledgeFeed/selectors";
import { getTmSelectedId, getTmSelectedOuterNodeId } from "domains/transformationMap/selectors";
import { fetchKnowledgeFeedForTopic } from "entities/knowledgeFeed/actions";

export function* applyLatestSearchCriteriaSaga(action: TopicLatestApplySearchCriteria) {
  const searchCriteria: ReturnType<typeof getLatestSearchCriteria> = yield select(getLatestSearchCriteria);
  const tmSelectedId: ReturnType<typeof getTmSelectedId> = yield select(getTmSelectedId);
  const secondaryTopicId: ReturnType<typeof getTmSelectedOuterNodeId> = yield select(getTmSelectedOuterNodeId);

  const id = action.payload?.topicId ?? tmSelectedId;
  if (id !== undefined) yield put(fetchKnowledgeFeedForTopic({ ...searchCriteria, id, secondaryTopicId }));
}
